import { ApiService } from './../../../services/api.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '../../../abstraction/auth.service';
import { TWOFA_STATUS } from '../../../models/User';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-second-factor-dialog',
  templateUrl: './second-factor-dialog.component.html',
  styleUrls: ['./second-factor-dialog.component.scss'],
})
export class SecondFactorDialogComponent implements OnInit {
  isActivationDialog: boolean;
  qrLoading = true;
  showBackUpCode = false;
  qrBackUpCode: string;
  showActivationErrorMesssage = false;
  pin = '';
  invalidCode = false;
  otpauthURL: string;

  constructor(
    public dialogRef: MatDialogRef<SecondFactorDialogComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: ApiService,
    public auth: AuthService,
  ) {}

  ngOnInit(): void {
    this.isActivationDialog = this.data.type === 'activate' ? true : false;
    if (this.isActivationDialog) {
      this.getQrImage();
    }
  }

  getQrImage() {
    this.api.show2FAQr().subscribe(
      (res) => {
        this.qrBackUpCode = res.backup.replace(/-/g, '');
        const issuer = 'TiendaCrypto';
        const account = `${this.auth.loggedUser.data.firstName} ${this.auth.loggedUser.data.lastName}`;
        this.otpauthURL = `otpauth://totp/${encodeURIComponent(issuer)}:${encodeURIComponent(
          account,
        )}?secret=${this.qrBackUpCode}&issuer=${encodeURIComponent(issuer)}`;
        setTimeout(() => {
          this.qrLoading = false;
        }, 1000);
      },
      (error) => {
        console.log(error);
      },
    );
  }

  activate2FA() {
    this.showActivationErrorMesssage = false;
    this.invalidCode = false;
    this.api.verifyActivation2FA(this.pin).subscribe(
      (res) => {
        this.auth.loggedUser.security.twoFA.status = TWOFA_STATUS.ACTIVE;
        this.dialogRef.close('activated');
        this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
          panelClass: 'modal-container',
          data: {
            title: '¡2FA Activado!',
            content: `Activaste la autenticación de dos factores para el inicio de sesión`,
          },
        });
      },
      (error) => {
        this.pin = '';
        this.invalidCode = true;
      },
    );
  }

  deactivate2FA() {
    this.showActivationErrorMesssage = false;
    this.invalidCode = false;
    this.api.verifyDeactivation2FA(this.pin).subscribe(
      () => {
        this.auth.loggedUser.security.twoFA.status = TWOFA_STATUS.INACTIVE;
        this.dialogRef.close('deactivated');
        this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
          panelClass: 'modal-container',
          data: {
            title: '¡2FA Desactivado!',
            content: `Desactivaste la autenticación en dos factores para el inicio de sesión`,
          },
        });
      },
      (error) => {
        this.pin = '';
        this.invalidCode = true;
      },
    );
  }

  toggleBackUp() {
    this.showBackUpCode = !this.showBackUpCode;
  }

  enterPressed() {
    if (this.isActivationDialog) {
      this.activate2FA();
    } else {
      this.deactivate2FA();
    }
  }

  fillCode(value: string) {
    this.pin = value;
  }
}
